import { UseBaseQueryOptions, useQuery } from '@tanstack/react-query'
import { getCoupons } from '../../services'
import { BatchesQueryKeys } from '@/modules/batches/keys'
import { GetCouponsRequest, GetCouponsResponse } from '@/modules/batches/type'

export default function useQueryGetCoupons(
	payload: GetCouponsRequest,
	props?: UseBaseQueryOptions<GetCouponsResponse>,
) {
	return useQuery({
		queryKey: [BatchesQueryKeys.GetCoupons, payload],
		queryFn: () => getCoupons(payload),
		...props,
	})
}
